import { render, staticRenderFns } from "./liucheng-2.vue?vue&type=template&id=eb142cc8&scoped=true"
import script from "./liucheng-2.vue?vue&type=script&lang=js"
export * from "./liucheng-2.vue?vue&type=script&lang=js"
import style0 from "./liucheng-2.vue?vue&type=style&index=0&id=eb142cc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb142cc8",
  null
  
)

export default component.exports